import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

// Simple Rating component
const Rating = ({ rating }) => {
    return (
        <div className="flex mb-4">
            {[...Array(5)].map((_, i) => (
                <svg
                    key={i}
                    className={`w-5 h-5 ${
                        i < rating ? 'text-yellow-400' : 'text-gray-300'
                    }`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
            ))}
        </div>
    )
}

export const SingleTestimonial = ({ review }) => {
    // Handle case where review is a simple object with text and author
    if (typeof review === 'string' || !review.client) {
        const text = review.text || review
        const author = review.author || 'Tracy Ritchey'

        return (
            <div className="flex flex-col items-center text-center space-y-4 h-full">
                <Rating rating={5} />
                <p className="text-base md:text-lg">{text}</p>
                <h3 className="text-base md:text-lg font-bold">{author}</h3>
            </div>
        )
    }

    // Original structure handling
    return (
        <div className="flex flex-col items-center text-center space-y-4 h-full">
            {Number(review.ratings) > 0 && (
                <Rating rating={Number(review.ratings)} />
            )}
            {review.text && <p className="text-base">{review.text}</p>}
            {review.client?.name && (
                <h3 className="text-base md:text-lg font-bold">
                    {review.client.name}
                </h3>
            )}
            {review.client?.photo && (
                <img
                    src={review.client.photo.sizes.thumbnail}
                    alt={review.client.name}
                    height={review.client.photo.sizes['thumbnail-height']}
                    width={review.client.photo.sizes['thumbnail-width']}
                    className="rounded-full mt-2"
                />
            )}
        </div>
    )
}

export default function Testimonials({
    reviews,
    slidePerPage = 1,
    sliderMinHeightClass,
}) {
    // If reviews is not provided or empty, create a default testimonial from the image
    const defaultTestimonial = {
        text: "Direct mail STILL WORKS if you use Open Letter Marketing. My favorite are ROS letters and postcards for generating wholesale leads. To date, I have spent just $1,250 in marketing through this company, and I closed 2 deals, earning $24,000 in assignment fees. And I'm still getting hot leads! The best part about the ROS letters/postcards is the sellers are HIGHLY motivated and prepared for an offer in my ballpark... and they call me! I'm preparing another order and I'm confident I'll get more deals out of it. I hope Open Letter Marketing never discontinues their ROS letters/postcards because they are absolute fire!",
        author: 'Tracy Ritchey',
        ratings: 5,
    }

    // Use provided reviews or fallback to default
    const textReviews =
        reviews && reviews.length > 0
            ? reviews
                  .filter((r) => r.type === 'Text')
                  .sort((a, b) => a.text.length - b.text.length)
            : [defaultTestimonial]

    const settings = {
        arrows: false,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: true,
        infinite: true,
        adaptiveHeight: true,
        slidesToShow: slidePerPage,
        slidesToScroll: 1,
        speed: 500,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false, // Hide arrows on mobile
                },
            },
        ],
        appendDots: (dots) => (
            <ul
                style={{
                    margin: '0px',
                    bottom: '-80px',
                }}>
                {dots}
            </ul>
        ),
        customPaging: () => (
            <span className="inline-block w-3 h-3 rounded-full bg-gray-300 hover:bg-yellow-400 mx-1 my-2"></span>
        ),
        prevArrow: <button className="slick-prev">Previous</button>,
        nextArrow: <button className="slick-next">Next</button>,
    }

    return (
        <div className="relative px-2 sm:px-4 md:px-8 py-6 md:py-12 max-w-full md:max-w-6xl mx-auto">
            {' '}
            {/* Added pb-16 for more space below */}
            <div className="w-full max-w-full">
                {' '}
                {/* Container to constrain width */}
                <Slider {...settings}>
                    {textReviews.map((review, index) => (
                        <div
                            key={index}
                            className={`outline-none px-2 ${
                                sliderMinHeightClass
                                    ? `${sliderMinHeightClass}`
                                    : ''
                            }`}>
                            {' '}
                            <div className="bg-olm-gradient-t-to-b p-[1px] h-full flex items-center flex-col text-center rounded-xl shadow-lg">
                                <div className="bg-white p-4 md:p-6 rounded-xl h-full w-full">
                                    <SingleTestimonial review={review} />
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    )
}
